module.exports = __webpack_public_path__ + "img/shop_taobao.d59581e1.png";